export default {
  spine: {
    title: 'Spine',
    parts: {
      neck: 'Neck',
      thoracic: 'Upper back',
      lumbar: 'Lower back',
    }
  },

  upperLimb: {
    title: 'Upper Limb',
    parts: {
      shoulderFrontLeft: 'Shoulder (Front-Left)',
      shoulderFrontRight: 'Shoulder (Front-Right)',
      shoulderBackLeft: 'Shoulder (Back-Left)',
      shoulderBackRight: 'Shoulder (Back-Right)',
      upperArmLeft: 'Upper arm (Left)',
      upperArmRight: 'Upper arm (Right)',
      elbowLeft: 'Elbow (Left)',
      elbowRight: 'Elbow (Right)',
      forearmLeft: 'Forearm (Left)',
      forearmRight: 'Forearm (Right)',
      handAndWristLeft: 'Hand and Wrist (Left)',
      handAndWristRight: 'Hand and Wrist (Right)',
    },
  },

  lowerLimb: {
    title: 'Lower Limb',
    parts: {
      hipLeft: 'Hip/Pelvis (Left)',
      hipRight: 'Hip/Pelvis (Right)',
      groinLeft: 'Groin (Left)',
      groinRight: 'Groin (Right)',
      thighFrontLeft: 'Thigh (Front-Left)',
      thighFrontRight: 'Thigh (Front-Right)',
      thighBackLeft: 'Thigh (Back-Left)',
      thighBackRight: 'Thigh (Back-Right)',
      kneeLeft: 'Knee (Left)',
      kneeRight: 'Knee (Right)',
      posteriorKneeLeft: 'Posterior Knee (Left)',
      posteriorKneeRight: 'Posterior Knee (Right)',
      shinLeft: 'Shin (Left)',
      shinRight: 'Shin (Right)',
      calfLeft: 'Calf (Left)',
      calfRight: 'Calf (Right)',
      footAndAnkleLeft: 'Foot and Ankle (Left)',
      footAndAnkleRight: 'Foot and Ankle (Right)',
      heelLeft: 'Heel (Left)',
      heelRight: 'Heel (Right)',
    },
  },
}
